var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentacasaIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32373 0.256116C1.15305 2.81957 1.35073 20.5746 7.32359 23.1382C13.0803 24.8966 24.0003 17.4312 24.0003 11.6842C24.0003 5.93717 11.9963 -1.47607 7.32373 0.256116ZM14.6331 10.5677C15.2414 12.063 14.544 13.7771 13.0754 14.3964C11.6068 15.0157 9.92309 14.3057 9.31478 12.8105C8.70644 11.3154 9.40386 9.60119 10.8725 8.98189C12.3411 8.36256 14.0248 9.07258 14.6331 10.5677Z",
    fill: "#582DC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37706 12.749C9.97503 14.2392 11.6372 14.98 13.0806 14.3627C15.4139 13.3649 18.0688 14.474 19.0353 16.8828C20.0017 19.2917 18.8938 22.0532 16.5605 23.051C11.6066 25.1695 0 17.1756 0 11.6476C0 6.11962 11.2383 -1.4619 16.5603 0.244847C18.8936 1.24262 20.0017 4.00423 19.0352 6.41306C18.0686 8.8219 15.4139 10.035 13.0806 9.03722C12.3807 8.73789 11.6017 8.72618 10.8743 9.03722C9.45589 9.68272 8.8255 11.2159 9.37706 12.749Z",
    fill: "#9573E8",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentacasaIconNew);
export default __webpack_public_path__ + "static/media/dentacasa-icon-new.45786769b95086f6b5f0109b491a8d5d.svg";
export { ForwardRef as ReactComponent };